// Renommer en "ApproveFollower" si nécessaire ou ajouter un commentaire explicatif
// Cette classe est utilisée après acceptation d'une demande

export default class FollowUser {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  /**
   * Suivre un utilisateur
   * @param {string} currentUserId - ID de l'utilisateur qui suit
   * @param {string} targetUserId - ID de l'utilisateur à suivre
   * @returns {Promise<boolean>} - Résultat de l'opération
   */
  async execute(currentUserId, targetUserId) {
    try {
      console.log(`FollowUser - Approbation de l'abonnement: ${currentUserId} → ${targetUserId}`);
      return await this.userRepository.followUser(currentUserId, targetUserId);
    } catch (error) {
      console.error('Erreur dans FollowUser UseCase:', error);
      throw error;
    }
  }
} 